<template>
  <div style="height: 450px;">
    <el-dialog top="2vh" v-if="replaceBadWord.show"
               :title="'Tin nhắn gửi đi có chứa '+replaceBadWord.items.length+' từ khóa nhạy cảm'" width="500px"
               :visible.sync="replaceBadWord.show" append-to-body>
      <div>
        <div>
          <div class="d-flex fw-bolder font-size-14 mb-3">
            <div class="w-150px">Từ cấm</div>
            <div class="flex-1">Từ thay thế</div>
            <div style="width: 60px"></div>
          </div>
          <div class="divider-custom"></div>
          <div style="max-height: 200px;overflow-y: auto;">
            <div v-for="(item,index) in replaceBadWord.items" :key="index">
              <div class="d-flex font-size-14 my-2">
                <div class="w-150px">
                  <div class="d-flex">
                    <div class="">{{ item.key }}</div>
                  </div>
                </div>
                <div class="flex-1">
                  <el-input placeholder="Nội dung thay thế" @input="handleInputReplace(item)"
                            v-model="item.replace"></el-input>
                </div>

              </div>
              <div class="divider-custom"></div>
            </div>
          </div>
        </div>
        <div class="my-2 ">Nội dung sau chỉnh sửa</div>
        <el-input
          ref="inputText"
          resize="none"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 5}"
          v-model="replaceBadWord.content"
          disabled
        />
        <div class="d-flex justify-content-end mt-2">
          <el-button size="sm" plain type="danger" @click="closeReplaceBadWord()">Hủy</el-button>
          <el-button size="sm" type="primary" @click="sendReplace()">Gửi tin nhắn</el-button>
        </div>
      </div>
    </el-dialog>
    <div v-if="accounts.length>0">
      <div class="d-flex">
        <div style="min-width: 250px">
          <div class="d-flex px-2">
            <h3 class="fw-semibold mt-1 font-size-15">Tài khoản</h3>
            <div class="mx-1"></div>
            <el-select class="flex-1 " @change="changeAccount" v-model="filter.selectAccountId" filterable
                       default-first-option
                       placeholder="Chọn tài khoản" size="mini">
              <el-option v-for="account in accounts" :key="account.accountId" :label="getAccountName(account)"
                         :value="account.accountId"></el-option>
            </el-select>
          </div>
          <div class="d-flex px-2 mt-1">
            <el-input
              size="mini"
              ref="inputMesage"
              @input="searchKeyChanged"
              v-model="filter.searchKey"
              placeholder="Nhập số điện thoại..."
              class="mt-1 flex-1"
              @keydown.enter.exact.native="searchContact()"
            ></el-input>
          </div>
          <div class="mt-1 px-2" v-if="filter.profile?.avatar">
            <div class="d-flex" style="height: 132px;position: relative">
              <el-image :src="filter.profile.cover" fit="fill" class="w-100" />
              <div style="position: absolute;bottom: -30px;left: 0;right: 0;height: 80px">
                <div class="flex-column">
                  <div class="d-flex justify-content-center font-size-17 fw-semibold">
                    <el-avatar :src="filter.profile.avatar" class="rounded-circle" alt="" :size="80" />
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: 36px">
              <div class="d-flex justify-content-center font-size-20 fw-semibold">
                {{ filter.conversation.swName ? filter.conversation.swName : filter.conversation.toName }}
              </div>
            </div>
            <div v-if="filter.showConversation">
              <div v-if="disableInfo().show">
                <div v-if="showInput">
                  <div v-if="selectType=='friend'" class="mt-4">
                    <el-input v-model="content" type="textarea" resize="none" :rows="4"
                              placeholder="Nhập lời mời kết bạn"
                              :maxlength="150" show-word-limit />
                  </div>
                  <div v-if="selectType=='message'" class="mt-4">
                    <el-input class="text-break" v-model="content" type="textarea" resize="none" :rows="4"
                              placeholder="Nhập nội dung tin nhắn" />
                  </div>
                </div>
                <div class="d-flex justify-content-center mt-1" v-else>
                  <el-button class="" size="mini" type="primary" plain @click="showMessageInput()">Nhắn tin
                  </el-button>
                  <el-button class="" size="mini" type="danger" @click="undoFriendRequest()"
                             :disabled="filter.profile.isBlocked !== null && filter.profile.isBlocked === 1"
                             plain
                             v-if="requestFriend.is_requested===1">Thu hồi
                  </el-button>
                  <el-button class="" size="mini" @click="showAddFriend()"
                             :disabled="filter.profile.isBlocked !== null && filter.profile.isBlocked === 1" plain
                             v-else-if="filter.profile.isFr===0">Kết
                    bạn
                  </el-button>
                </div>
                <div v-if="showInput" class="d-flex justify-content-end mt-1">
                  <el-button size="mini" type="danger" plain @click="showInput=false">Hủy</el-button>

                  <el-button size="mini" type="primary" @click="addFriend()"
                             v-if="selectType=='friend'">Kết bạn
                  </el-button>
                  <el-button size="mini" type="primary" @click="sendMessage()" v-else>Gửi</el-button>
                </div>
                <div class="flex-column mt-3" v-else>

                  <div class="font-size-16 fw-semibold">Thông tin cá nhân</div>
                  <div class="d-flex mt-1">
                    <div class="w-100px mx-1 text-secondary">Giới tính:</div>
                    <div class="flex-1"> {{ filter.profile.gender === 0 ? "Nam" : "Nữ" }}</div>
                  </div>
                  <div class="d-flex mt-1">
                    <div class="w-100px mx-1 text-secondary">Ngày sinh:</div>
                    <div class="flex-1"> {{ filter.profile.sdob }}</div>
                  </div>
                  <div class="d-flex mt-1">
                    <div class="w-100px mx-1 text-secondary">Số điện thoại:</div>
                    <div class="flex-1"> {{ filter.profile.phoneNumber }}</div>
                  </div>
                </div>
              </div>
              <div class="text-break d-flex text-danger" v-else>{{ disableInfo().message }}</div>
            </div>
            <div class="text-break d-flex text-danger" v-else>Bạn không có quyền tương tác với liên hệ này!</div>
          </div>
        </div>
        <div style=" border-left: 1px solid #DCDFE9;height: 400px"></div>
        <div class="flex-1 px-2" v-if="filter.showConversation">
          <div class="d-flex">
            <h3 class="font-size-14 fw-semibold mt-1">Danh sách tag</h3>
            <div class="mx-1" />
            <el-select class="flex-1 " @change="changeTagOpt()" v-model="selectTagOpt"
                       placeholder="Chọn tag" size="mini">
              <el-option v-for="tag in tagOpt" :key="tag.val" :label="tag.key"
                         :value="tag.val"></el-option>
            </el-select>
          </div>
          <div style="border:1px solid #DCDFE9 " class="p-1 mt-2">
            <div class="p-1 d-flex justify-content-start flex-wrap "
                 style="overflow-y: auto ;max-height: 250px; max-width: 600px;">
              <div v-for="item in tagView" :key="item.id" @click="addOrRemoveTag(item)">
                <TagCustom :item="item" :selected="isSelected(item)" :is-button="true" />
              </div>
            </div>
          </div>
          <div class="mt-2" v-if="filter.showConversation">
            <h3 class="font-size-14">Tag đã gắn</h3>
            <div style="min-height: 120px;max-height: 120px;border:1px solid #DCDFE9 " class="p-1 mt-2">
              <div class="p-1 d-flex flex-wrap">
                <div v-for="item in filter.conversation.tags" :key="item.id">
                  <TagCustom v-if="showTag(item.id)" :item="item" :selected="true" :is-button="true" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="d-flex justify-content-center mt-4">
      Không có tài khoản nào được chọn
    </div>
  </div>
</template>

<script>
import TagCustom from "@/components/common/TagCustom";
import { HTTP } from "@/lib/http-common";

export default {
  name: "SearchNewContact",
  components: { TagCustom },
  data() {
    return {
      accounts: [],
      filter: this.newFilter(),
      tagOpt: [
        { key: "Tất cả tag", val: 0 },
        { key: "Tag chỉ định", val: 1 },
        { key: "Tag thường", val: 2 }
      ],
      selectTagOpt: 0,
      tags: [],
      tagView: [],
      requestFriend: {},
      selectType: "message",
      content: "",
      showInput: false,
      replaceBadWord: {
        show: false,
        items: [],
        content: ""
      }
    };
  },
  methods: {
    showAddFriend() {
      this.content = "Xin chào " + this.filter.profile.displayName + ", kết bạn với mình nhé!";
      this.selectType = "friend";
      this.showInput = true;
    },
    addFriend() {
      this.$http.get("/api/contact/addFriend", {
        params: {
          msg: this.content,
          userId: this.filter.conversation.toId,
          accountId: this.filter.conversation.accountId
        }
      }).then((resp) => {
        if (resp.data.error_code === 0) {
          let request = {
            accountId: this.filter.conversation.accountId,
            friendId: this.filter.conversation.toId
          };
          this.$http.post("/api/conversation/friendRequestStatus", request).then((resp) => {
            let data = resp.data.data;
            if (data.is_requested === 1) {
              this.alert("success", "Gửi kết bạn thành công !");
            } else {
              this.alert("error", "Người dùng này đã từ chối trước đó");
            }
            this.showInput = false;
            this.requestFriend.is_requested = 1;
          });
        } else if (resp.data.error_code === 222) {
          this.$set(this.filter.profile, "isFr", 1);
        } else if (resp.data.error_code !== 0) {
          return this.alert("error", resp.data.error_message);
        }
      });
    },
    undoFriendRequest() {
      this.$http.get("/api/contact/undoFriendRequest", {
        params: {
          accountId: this.filter.conversation.accountId,
          userId: this.filter.conversation.toId
        }
      }).then((resp) => {
        if (resp.data.error_code !== 0) {
          this.alertError(resp.data.error_message);
        }
      });
      this.alert("success", "Đã thu hồi lời mời kết bạn !");
      this.requestFriend.is_requested = 0;
    },
    handleInputReplace() {
      this.replaceBadWord.items.forEach((it) => {
        for (let item of this.filterCharacterArr()) {

          if (it.replace.toLowerCase() == item.content.toLowerCase()) {
            it.replace = "****";
          }
        }
      });
      this.replaceBadWordContent();
    },
    replaceBadWordContent() {
      this.replaceBadWord.content = this.content;
      this.replaceBadWord.items.forEach((item) => {
        this.replaceBadWord.content = this.replaceBadWord.content.replaceAll(item.key, item.replace);
      });
    },
    filterCharacter() {
      let items = [];
      let check = true;
      let fil = this.app.accountSetting.filter(p => p.accountId == this.filter.conversation.accountId);
      if (fil != null && fil.length > 0) {
        check = fil[0].checkBadWord;
      }
      if (check) {
        let text = this.content;
        let arr = text.split(" ");
        if (this.filterCharacterArr() && this.filterCharacterArr().length > 0 && arr.length > 0) {
          for (let item of this.filterCharacterArr()) {
            arr.forEach((it) => {
              if (it.toLowerCase() == item.content.toLowerCase()) {
                let fil = items.filter((f) => f.key == it);
                if (fil == null || fil.length == 0) {
                  items.push({ key: it, replace: "****" });
                }
              }
            });
          }
        }
      }
      return items;
    },
    sendMessage() {
      if (!this.content) {
        this.alert("error", "Nhập nội dung cần gửi.");
        return;
      }
      let items = this.filterCharacter();
      if (items.length > 0) {
        this.replaceBadWord.show = true;
        this.replaceBadWord.items = items;
        this.replaceBadWordContent();
      } else {
        this.sendMesV2();
        // let request = {
        //   accountId: this.filter.conversation.accountId,
        //   toId: this.filter.conversation.toId,
        //   groupId: this.filter.conversation.toId,
        //   message: this.content
        // };
        // let url = "/api/message/sms";
        // this.$http.post(url, request).then((resp) => {
        //   this.content = "";
        //   this.showInput = false;
        //   if (resp.data.error_code === 0) {
        //     this.alert("success", "Đã gửi tin nhắn");
        //   } else if (resp.data.error_code !== 0) {
        //     this.alert("error", resp.data.error_message);
        //   }
        // });
        this.sendMesV2();
      }
    },
    closeReplaceBadWord() {
      this.showInput = false;
      this.replaceBadWord.show = false;
    },
    sendMesV2(keys, replace) {
      let request = {
        accountId: this.filter.conversation.accountId,
        toId: this.filter.conversation.toId,
        message: this.content,
        conversationId: this.filter.conversation.id,
        bannedKeyword: keys ? keys : [],
        replace: replace
      };
      this.content = "";
      this.$http.post("/api/message/sms", request);
      this.closeReplaceBadWord();
    },
    sendReplace() {
      this.content = this.replaceBadWord.content;
      this.sendMesV2(this.replaceBadWord.items.map((k) => {
        return k.key;
      }), true);
    },
    disableInfo() {
      let resp = { show: true, message: "" };
      if (!this.isUserTypeAdmin()) {
        let count = this.filter.conversation.tags.filter(t => t.assign && t.status == "ACTIVE");
        if (count != null && count.length > 0) {
          resp.show = false;
          resp.message = "Liên hệ này đã được gắn tag chỉ định, Bạn không có quyền tương tác với liên hệ này!";
          count.forEach(item => {
            let it = this.app.tagAssignMe.filter(t => t.id == item.id);
            if (it != null && it.length > 0) {
              resp.show = true;
            }
          });
        } else {
          if (this.app.showAllContact) {
            resp.show = true;
          } else {
            resp.show = false;
            resp.message = "Bạn cần gắn tag chỉ định trước khi tương tác với liên hệ này !";
          }
        }

      }
      return resp;
    },
    showMessageInput() {
      this.content = "";
      this.selectType = "message";
      this.showInput = true;
    },
    showTag(tagId) {
      let it = this.tags.filter(t => t.id == tagId);
      if (it != null && it.length > 0) {
        return true;
      }
      return false;
    },
    getTagFilter() {
    },
    isSelected(item) {
      if (this.filter.conversation?.id) {
        let it = this.filter.conversation.tags.filter(t => t.id == item.id);
        if (it != null && it.length > 0)
          return true;
      }
      return false;
    },
    addOrRemoveTag(tag) {
      const index = this.filter.conversation.tags.findIndex(t => {
        return t.id == tag.id;
      });
      if (index > -1) {
        this.filter.conversation.tags.splice(index, 1);
      } else {
        this.filter.conversation.tags.push(tag);
      }
      let request = {
        conversationId: this.filter.conversation.id,
        tagId: tag.id
      };
      this.$http.post("/api/conversation/tag", request);
    },
    changeTagOpt() {
      if (this.selectTagOpt == 0) {
        this.tagView = this.tags;
      } else if (this.selectTagOpt == 1) {
        this.tagView = this.tags.filter(p => p.assign);
      } else {
        this.tagView = this.tags.filter(p => !p.assign);
      }
    },
    newFilter() {
      return {
        searchKey: "",
        selectAccountId: "",
        conversation: { id: "" },
        showConversation: false,
        profile: {}
      };
    },
    searchKeyChanged(event) {
      this.filter.searchKey = event.replace(/[^0-9]/g, "");

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.searchContact();
      }, 700);
    },
    searchContact() {

      let searchKey = this.filter.searchKey;
      this.filter.showConversation = false;
      this.filter.conversation = { id: "" };
      this.filter.profile = {};
      if (searchKey.length < 9) return;
      if (searchKey.startsWith("0")) searchKey = "+84" + searchKey.substring(1);
      HTTP.post("/api/search/searchNewContact", {
          searchKey: searchKey,
          accountId: this.filter.selectAccountId
      }).then((res) => {
        this.filter.showConversation = res.data.showConversation;
        this.filter.conversation = res.data.conversation;
        this.filter.profile = res.data.profile;
        if(this.filter.conversation){
          HTTP.post("/api/conversation/friendRequestStatus", {
            accountId: this.filter.conversation.accountId,
            friendId: this.filter.conversation.toId
          }).then((resp) => {
            if (resp.data.error_code === 0) {
              this.requestFriend = resp.data.data;
            }
          });
        }
      });
    },
    changeAccount() {
      this.searchContact();
    },
    getTags() {
      HTTP.get("/api/tag").then((resp) => {
        this.tags = resp.data;
        this.changeTagOpt();
      });
    },
    getAccounts() {
      // HTTP.get("/api/account/getAll").then((resp) => {
          // if (resp.status === "success") {
            this.accounts = this.app.accounts;
            this.filter.selectAccountId = this.accounts[0].accountId;
          // }
        // }
      // );
    },

    filterCharacterArr() {
      const characterArr = this.app.characterFilters;
      const arrCommon = characterArr["0"];
      const arrOnwerAccount = characterArr[this.filter.selectAccountId];
      let array = [];
      if (arrCommon && arrCommon.length > 0) {
        array.push(...arrCommon);
      }
      if (arrOnwerAccount && arrOnwerAccount.length > 0) {
        array.push(...arrOnwerAccount);
      }
      const key = "content";
      const unique = [...new Map(array.map(item => [item[key], item])).values()];
      return unique;
    }
  },

  created() {
    this.getAccounts();
    this.getTags();

    this.filter = this.newFilter();
  }
};
</script>

<style scoped>

</style>
